import {Card} from 'antd';
import React from 'react';

const TrustedBy: React.FC = () => {
	// Sample testimonial data
	const testimonial = {
		quote: '"We have been extremely impressed with Permworks. It has made the process of growing our team with high quality talent a breeze."',
		name: 'Emma H',
		title: 'Founder @ Shoestring Services',
		timeToPlacement: '1 weeks',
	};

	// Sample brand logos
	const brands = [
		{name: 'Waverio', image: '/images/trusted-by/bhg.png'},
		{name: 'LogoIpsum', image: '/images/trusted-by/ww.png'},
		{name: 'Alterbone', image: '/images/trusted-by/kp.png'},
		{name: 'Waverio', image: '/images/trusted-by/artichoke.png'},
		{name: 'LogoIpsum', image: '/images/trusted-by/cc3.png'},
		{name: 'Alterbone', image: '/images/trusted-by/emega.png'},
		{name: 'Waverio', image: '/images/trusted-by/guardhouse.png'},
		{name: 'LogoIpsum', image: '/images/trusted-by/integritech.png'},
	];

	return (
		<section className="py-10 bg-white">
			<div className="container mx-auto px-4">
				<h2 className="text-2xl font-normal text-center mb-12">Trusted by 1000+ popular brands.</h2>

				<div className="flex flex-col md:gap-10 lg:flex-row items-start justify-between max-w-[1100px] mx-auto">
					{/* Testimonial */}
					<div className="lg:w-2/5 mb-10 lg:mb-0 pr-8">
						<div className="flex items-start">
							<div className="mr-4">
								<img className="min-w-14 min-h-14 w-14 h-14 rounded-full object-cover" src="/images/trusted-by/recr.webp" alt="Recruiter" />
							</div>

							<div className="border-l-3 border-linkBlue pl-4">
								<p className="text-darkCharcoal mb-4">{testimonial.quote}</p>
								<p className="font-semibold text-deepBlue">{testimonial.name}</p>
								<p className="text-charcoal text-sm">{testimonial.title}</p>
							</div>
						</div>
					</div>

					{/* Brand logos */}
					<div className="lg:w-3/5 flex flex-col gap-4 mx-auto">
						<div className="grid grid-cols-2 md:grid-cols-4 gap-4">
							{brands.slice(0, 4).map((brand, index) => (
								<Card key={index} className="flex items-center justify-center" size="small">
									<img src={brand.image} alt={brand.name} className=" object-cover w-24 h-18" />
								</Card>
							))}
						</div>
						<div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:mr-[-20px] md:ml-[20px]">
							{brands.slice(4).map((brand, index) => (
								<Card key={index + 4} className="flex items-center justify-center" size="small">
									<img src={brand.image} alt={brand.name} className="object-cover w-24 h-18" />
								</Card>
							))}
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default TrustedBy;
